import * as $ from "jquery";
import {InventoryLocationInteractionLocation} from "./interactions/location";
import {
    InventoryLocationInteractionObserversLine
} from "./interactions/observers-line";
import {InventoryLocationInteractionBeatersLine} from "./interactions/beaters-line";
import {InventoryLocationInteractionThermalImagingAreas} from "./interactions/thermal-imaging-areas";
import {InventoryLocationInteractionThermalImagingTransects} from "./interactions/thermal-imaging-transects";
import {InventoryLocationInteractionThermalImagingRoutes} from "./interactions/thermal-imaging-routes";

export class InventoryLocationInteractionsHandler {
    /**
     * @type {EpMap}
     */
    epMap = null;

    /**
     * @type {InventoryLocationInteraction|null}
     */
    currentModeInteraction = null;

    interactions = {};

    constructor(epMap) {
        this.epMap = epMap;
        this.epMap.customInteractions = this;

        this.interactions = {
            location: new InventoryLocationInteractionLocation(this),
            observers_line: new InventoryLocationInteractionObserversLine(this),
            beaters_line: new InventoryLocationInteractionBeatersLine(this),
        }

        this.mapUpdated();

        for(let interaction in this.interactions) {
            this.interactions[interaction].onChange();
        }
    }


    mapUpdated() {
        for (let name in this.interactions) {
            if (this.interactions[name].toggleButton) {
                $(`[data-app-manual_group="${name}"]`).show();
            }
        }
    }

    setCurrentInteraction(interaction) {
        if (this.currentModeInteraction !== null) {
            this.currentModeInteraction.end(this.currentModeInteraction.name !== interaction?.name);

            if (this.currentModeInteraction?.name === interaction?.name) {
                this.currentModeInteraction = null;
                this.currentModeInteraction = null;
                return null;
            }
        }

        this.currentModeInteraction = interaction;

        return interaction;
    }
}